import { isBefore } from '@formkit/tempo'

export function compareScheduleTimes(left, right) {
  if (isBefore(left, right)) return -1
  if (isBefore(right, left)) return 1
  return 0
}
